import RetailerSubscriptionBox from './RetailerSubscriptionBox'

export default RetailerSubscriptionBox
